import type { App } from 'vue'
import MasonryWall from '@yeger/vue-masonry-wall'
import type { Component } from './types'
import {
  AiAssistant,
  AppBadge,
  AppButton,
  AppCard,
  AppCarousel,
  AppCollapse,
  AppDrawer,
  AppDropdown,
  AppDynamicInput,
  AppEmpty,
  AppForm,
  AppGrid,
  AppImage,
  AppInput,
  AppInputNumber,
  AppList,
  AppLoading,
  AppModal,
  AppNInputNumber,
  AppPagination,
  AppPopover,
  AppRadio,
  AppRadioButton,
  AppRadioGroup,
  AppScrollbar,
  AppSelect,
  AppSkeleton,
  AppSlider,
  AppSpace,
  AppSpin,
  AppSplit,
  AppSteps,
  AppSvgEIcon,
  AppSwitch,
  AppTable,
  AppTabs,
  AppTag,
  AppText,
  AppTooltip,
  AppTreeSelect,
  AppUpload,
  AppVirtualList,
  Breadcrumb,
  CreditIcon,
  HoverButton,
  LottieAnimation,
  MathFormula,
  NaiveProvider,
  PromptStore,
  SEO,
  Setting,
  SvgIcon,
} from '@/components/common'

const component = {
  install(Vue: Component): void {
    // App components
    Vue.component('AppTable', AppTable)
    Vue.component('AppSpin', AppSpin)
    Vue.component('AppLoading', AppLoading)
    Vue.component('AppPagination', AppPagination)
    Vue.component('AppInput', AppInput)
    Vue.component('AppUpload', AppUpload)
    Vue.component('AppSelect', AppSelect)
    Vue.component('AppText', AppText)
    Vue.component('AppPopover', AppPopover)
    Vue.component('AppRadio', AppRadio)
    Vue.component('AppRadioGroup', AppRadioGroup)
    Vue.component('AppRadioButton', AppRadioButton)
    Vue.component('AppGrid', AppGrid)
    Vue.component('AppCard', AppCard)
    Vue.component('AppDropdown', AppDropdown)
    Vue.component('AppModal', AppModal)
    Vue.component('AppButton', AppButton)
    Vue.component('AppCollapse', AppCollapse)
    Vue.component('AppDynamicInput', AppDynamicInput)
    Vue.component('AppTag', AppTag)
    Vue.component('AppSlider', AppSlider)
    Vue.component('AppSwitch', AppSwitch)
    Vue.component('AppTreeSelect', AppTreeSelect)
    Vue.component('AppInputNumber', AppInputNumber)
    Vue.component('AppNInputNumber', AppNInputNumber)
    Vue.component('AppForm', AppForm)
    Vue.component('AppImage', AppImage)
    Vue.component('AppList', AppList)
    Vue.component('AppSteps', AppSteps)
    Vue.component('AppTabs', AppTabs)
    Vue.component('AppBadge', AppBadge)
    Vue.component('AppSplit', AppSplit)
    Vue.component('AppTooltip', AppTooltip)
    Vue.component('AppScrollbar', AppScrollbar)
    Vue.component('AppVirtualList', AppVirtualList)
    Vue.component('AppDrawer', AppDrawer)
    Vue.component('AppEmpty', AppEmpty)
    Vue.component('AppSkeleton', AppSkeleton)
    Vue.component('AppCarousel', AppCarousel)
    Vue.component('AppSpace', AppSpace)

    // Common components
    Vue.component('HoverButton', HoverButton)
    Vue.component('NaiveProvider', NaiveProvider)
    Vue.component('SvgIcon', SvgIcon)
    Vue.component('CreditIcon', CreditIcon)
    Vue.component('Setting', Setting)
    Vue.component('PromptStore', PromptStore)
    Vue.component('Breadcrumb', Breadcrumb)
    Vue.component('AiAssistant', AiAssistant)
    Vue.component('LottieAnimation', LottieAnimation)
    Vue.component('MathFormula', MathFormula)
    Vue.component('SEO', SEO)
    Vue.component('AppSvgEIcon', AppSvgEIcon)
    Vue.component('AppMasonryWall', MasonryWall)
  },
}

const setupComponent = (app: App) => {
  app.use(component)
}

export default setupComponent
